import { CommonModule } from '@angular/common';
import {
  animate,
  keyframes,
  state,
  style,
  transition,
  trigger
} from '@angular/animations';
import { Component, OnInit } from '@angular/core';

import { Toast, ToastrService, ToastPackage, IndividualConfig } from 'ngx-toastr';
import { ApiService } from '../services/api.service';
import { Notification } from '../models/notification.model';
import { NotificationService } from '../services/notification.service';

// export interface CustomConfig extends IndividualConfig {
//   notificationId: number;
//   notificationMessage: string;
//   collapse: string;
// }

@Component({
  selector: '[custom-toast-component]',
  styleUrls: [`./notification-toast.component.css`],
  templateUrl: `./notification-toast.component.html`,
  imports: [CommonModule],
  animations: [
    trigger('flyInOut', [
      state('inactive', style({
        opacity: 0,
      })),
      transition('inactive => active', animate('400ms ease-out', keyframes([
        style({
          transform: 'translate3d(100%, 0, 0) skewX(-30deg)',
          opacity: 0,
        }),
        style({
          transform: 'skewX(20deg)',
          opacity: 1,
        }),
        style({
          transform: 'skewX(-5deg)',
          opacity: 1,
        }),
        style({
          transform: 'none',
          opacity: 1,
        }),
      ]))),
      transition('active => removed', animate('400ms ease-out', keyframes([
        style({
          opacity: 1,
        }),
        style({
          transform: 'translate3d(100%, 0, 0) skewX(30deg)',
          opacity: 0,
        }),
      ]))),
    ]),
  ],
  preserveWhitespaces: false,
})

export class NotificationToastComponent extends Toast implements OnInit{
  notificationPackage

  // constructor is only necessary when not using AoT
  constructor(
    protected override toastrService: ToastrService,
    public override toastPackage: ToastPackage,
    private api: ApiService,
    private notificationsService: NotificationService
  ) {
    super(toastrService, toastPackage);
    this.notificationPackage = toastPackage;
    this.notificationPackage.config.payload = {};
  }

  ngOnInit() {
    this.notificationPackage.config.payload.notificationId = (this.toastPackage.config as any).notificationId;
    if (this.notificationPackage && this.notificationPackage.message && this.notificationPackage.message.length > 60) {
      this.notificationPackage.config.payload.notificationMessage = this.notificationPackage.message.substring(0, 60) + '...';
      this.notificationPackage.config.payload.collapse = 'down';
    } else {
      this.notificationPackage.config.payload.notificationMessage = this.notificationPackage.message;
      this.notificationPackage.config.payload.collapse = 'up';
    }  
  }

  showMore() {
    let temp = this.notificationPackage.config.payload.notificationMessage;
    this.notificationPackage.config.payload.notificationMessage = this.notificationPackage.message;
    this.notificationPackage.message = temp;
    this.notificationPackage.config.payload.collapse = this.notificationPackage.config.payload.collapse == 'down' ? 'up' : 'down';
  }

  readNotification(notificationId: string) { 
    this.api.readNotification(notificationId).subscribe((data: any) => {
      if (data) { 
        this.notificationsService.updateNotificationsCounter(-1, false);
      } 
    }) ;
  }

}
